import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {BwAvailability} from '../models/bwAvailability';

@Injectable()
export class BwAvailabilityService {
  constructor(private httpClient: HttpClient) {
  }

  getBwAvailabilities(): Observable<BwAvailability[]> {
    return this.httpClient.get<BwAvailability[]>(environment.baseUrlWs + '/api/bw-availability');
  }

  changePublicDescription(id, publicDescription: string) {
    return this.httpClient.put<BwAvailability>(environment.baseUrlWs + '/api/bw-availability/' + id, {'publicDescription': publicDescription});
  }

  getBwAvailabilitiesForMap(): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/bw-availability-map');
  }
}
